import { render, staticRenderFns } from "./RequestSalaryAdvance.vue?vue&type=template&id=3a4ab008&scoped=true"
import script from "./RequestSalaryAdvance.vue?vue&type=script&lang=js"
export * from "./RequestSalaryAdvance.vue?vue&type=script&lang=js"
import style0 from "./RequestSalaryAdvance.vue?vue&type=style&index=0&id=3a4ab008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ab008",
  null
  
)

export default component.exports